import { ButtonWrapper, Content, Subtitle, ExtraLabel, UpperLabel } from './styles';
import { formattedTitle } from '@/utils/formatted-title';
import { Heading } from '@swordhealth/ui-corporate';
import EnrollButton from '@/app/components/core/EnrollButton';

const HeroJuneThematicContent = ({
  buttonLabel,
  client,
  label,
  openModal,
  subtitle,
  title,
  upperLabel,
  userName,
}) => {
  return (
    <Content>
      {upperLabel && <UpperLabel>{upperLabel}</UpperLabel>}

      <Heading as="h1" size="3xl" weight="bold">
        {formattedTitle({ title, userName })}
      </Heading>

      {subtitle && <Subtitle className="notGradient">{subtitle}</Subtitle>}

      <ButtonWrapper>
        <EnrollButton
          className="button"
          isActive={client.isActive}
          openModal={() => openModal({ buttonText: buttonLabel, buttonLocation: 'header' })}
          client={client}
          buttonLabel={buttonLabel}
          product={client?.product}
          redirectToApp={client?.redirectToApp}
        />

        {label && <ExtraLabel>{label}</ExtraLabel>}
      </ButtonWrapper>
    </Content>
  );
};

export default HeroJuneThematicContent;
